import React, { useState, useRef, useEffect } from "react";
import "../assets/css/Dropdown.css";

const Dropdown = ({ options, value, onChange, placeholder }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    onChange({ target: { value: option } });
    setOpen(false);
  };

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button className="dropdown-btn" onClick={() => setOpen(!open)}>
        {value || placeholder}
      </button>
      <ul className={`dropdown-menu ${open ? "open" : ""}`}>
        {options.map((opt) => (
          <li key={opt} onClick={() => handleSelect(opt)}>
            {opt}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Dropdown;
